export const DEFAULT_THEME = {};
